import noop from 'lodash/fp/noop';

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import { testReleasesActiveOptions, ALL } from '~/features/base/constants/filterOptions';
import { selectionByValue } from '~/features/base/utils/selectUtils';
import Select from '@rio-cloud/rio-uikit/lib/es/Select';

export class TestReleaseActiveFormItem extends Component {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(item) {
        this.props.onChange({
            testReleasesActive: item.id === ALL ? undefined : item.value,
        });
    }

    render() {
        const { label, value } = this.props;
        const optionsWithSelection = selectionByValue(value)(testReleasesActiveOptions);
        return (
            <div className='form-group'>
                <label className='control-label'>
                    <FormattedMessage id={label} />
                </label>
                <Select options={optionsWithSelection}
                    onChange={this.onChange} />
            </div>
        );
    }
}

export default TestReleaseActiveFormItem;

TestReleaseActiveFormItem.defaultProps = {
    // props
    label: 'intl-msg:testReleasesActive',
    value: ALL,
    // functions
    onChange: noop,
};

TestReleaseActiveFormItem.propTypes = {
    // props
    label: PropTypes.string,
    value: PropTypes.string,
    // functions
    onChange: PropTypes.func,
};
